import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { LoginState, loginReducer as login } from "./loginReducer";
import { UserData } from "../actions/authentificationActions";
import { userReducer as user } from "./userReducer";
import { filesReducer as files, FilesState } from "./filesReducer";
import { timestampsReducer as timestamps, TimestampsState } from "./timestampsReducer";
import { verticesReducer as vertices, VerticesState } from "./verticesReducer";
import { ccValidationReducer as ccValidation, CCValidationState } from "./ccValidationReducer";
import {
    additionalOutageReducer as additionalOutage,
    AdditionalOutageState,
} from "./additionalOutageReducer";
import { cgmBranchesReducer as cgmBranches, CGMBranchesState } from "./cgmBranchesReducer";
import { cbBranchesReducer as cbBranches, CBBranchesState } from "./cbBranchesReducer";
import { npShiftsReducer as npShifts, NPShiftsState } from "./npShiftsReducer";
import { verticesFilteringReducer as verticesFiltering, VerticesFilteringState } from "./verticesFilteringReducer";
import { raoReportReducer as raoReport, RAOReportState } from "./raoReportReducer";
import rootSaga from "../sagas/root";
import { toastReducer as toast, ToastState } from "./toastReducer";
import { usersReducer as users, UsersState } from "./usersReducer";
import { appInfoReducer as appInfo, AppInfoState } from "./appInfoReducer";
import { selectedTsosReducer as selectedTsos, SelectedTsosState } from "./selectedTsosReducer";
import {
    justificationsReducer as justifications,
    JustificationsState,
} from "./jusificationsReducer";
import { appStageReducer as appStage, AppStageState } from "./appStageReducer";
import { validationProcessReducer as validationProcess, ValidationProcessState } from "./validationProcess";
//import { intraDayReducer as intraDay, IntraDayState } from "./intraDayReducer";

export interface AppState {
    login: LoginState;
    user: UserData;
    files: FilesState;
    timestamps: TimestampsState;
    vertices: VerticesState;
    ccValidation: CCValidationState;
    additionalOutage: AdditionalOutageState;
    cgmBranches: CGMBranchesState;
    cbBranches: CBBranchesState;
    npShifts: NPShiftsState;
    verticesFiltering: VerticesFilteringState;
    raoReport: RAOReportState;
    toast: ToastState;
    users: UsersState[];
    appInfo: AppInfoState;
    selectedTsos: SelectedTsosState;
    justifications: JustificationsState[];
    appStage: AppStageState;
    validationProcess: ValidationProcessState
}

export default function configureStore(initialState?: AppState) {
    const rootReducer = combineReducers<AppState>({
        login,
        user,
        files,
        timestamps,
        vertices,
        ccValidation,
        additionalOutage,
        cgmBranches,
        cbBranches,
        npShifts,
        verticesFiltering,
        raoReport,
        toast,
        users,
        appInfo,
        selectedTsos,
        justifications,
        appStage,
        validationProcess,
    });

    const sagaMiddleware = createSagaMiddleware();

    const enhancers = [];
    const windowIfDefined = typeof window === "undefined" ? null : (window as any);
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }

    const result = createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(sagaMiddleware), ...enhancers)
    );

    sagaMiddleware.run(rootSaga);

    return result;
}
